package com.essntl.features.request.ui.allrequest.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing

@Composable
fun RequestStatusDropDown(
    status: RequestModel.Status,
    onStatusSelected: (RequestModel.Status) -> Unit,
    enabled: Boolean = true,
) {
    var isExpanded by remember {
        mutableStateOf(false)
    }

    Box {
        RequestStatus(
            status = status,
            suffixIconRes = if (enabled) EsIcons.ArrowDown else null,
            modifier = Modifier
                .clip(CircleShape)
                .pointerHoverIcon(PointerIcon.Hand)
                .focusProperties { canFocus = false }
                .clickable {
                    if (enabled)
                        isExpanded = true
                },
        )

        EsDropDownMenu(
            expanded = isExpanded,
            onDismissRequest = { isExpanded = false },
            paddingValues = PaddingValues(1.spacing),
            verticalArrangement = Arrangement.spacedBy(1.5f.spacing),
        ) {
            RequestModel.Status.entries.forEach { status ->
                RequestStatus(
                    status = status,
                    modifier = Modifier
                        .clip(CircleShape)
                        .pointerHoverIcon(PointerIcon.Hand)
                        .clickable {
                            onStatusSelected(status)
                            isExpanded = false
                        },
                )
            }
        }
    }
}